export default __webpack_public_path__ + "static/media/480_dummy2016-raumgestalter01-de.1c4d1687.png";